var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#home_svg__a)",
    fillRule: "evenodd",
    d: "M19.25 6.2 10 .102.75 6.2v12.55h18.5zm-17 11.05V7.008L10 1.898l7.75 5.11V17.25zm8.721-3.867 3.498-2.798-.937-1.17-2.503 2.001-2-1.8-3.498 2.798.938 1.171 2.502-2.002z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "home_svg__a",
    x1: 16.641,
    x2: -2.386,
    y1: 0.402,
    y2: 14.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#FF7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#15CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3BF2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#6675FF"
  })))));
};
export { SvgHome as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTkuMjUgNi4yMDA0NkwxMCAwLjEwMTU2MkwwLjc1IDYuMjAwNDZWMTguNzQ5OUgxOS4yNVY2LjIwMDQ2Wk0yLjI1IDE3LjI0OTlWNy4wMDgxNkwxMCAxLjg5ODI3TDE3Ljc1IDcuMDA4MTZWMTcuMjQ5OUgyLjI1Wk0xMC45NzE0IDEzLjM4M0wxNC40Njg1IDEwLjU4NTRMMTMuNTMxNSA5LjQxNDA2TDExLjAyODYgMTEuNDE2NEw5LjAyODU2IDkuNjE2NEw1LjUzMTQ4IDEyLjQxNDFMNi40Njg1MiAxMy41ODU0TDguOTcxNDQgMTEuNTgzTDEwLjk3MTQgMTMuMzgzWiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzM0NThfNjE1MzgpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMzQ1OF82MTUzOCIgeDE9IjE2LjY0MSIgeTE9IjAuNDAyMzQzIiB4Mj0iLTIuMzg2MTIiIHkyPSIxNC40OTY4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIG9mZnNldD0iMC4xMjYzMDIiIHN0b3AtY29sb3I9IiNGRjc4ODAiLz4KPHN0b3Agb2Zmc2V0PSIwLjM3NDQiIHN0b3AtY29sb3I9IiMxNUNGRTQiLz4KPHN0b3Agb2Zmc2V0PSIwLjYyNTE1NCIgc3RvcC1jb2xvcj0iIzNCRjJBNSIvPgo8c3RvcCBvZmZzZXQ9IjAuODc2MzQ4IiBzdG9wLWNvbG9yPSIjNjY3NUZGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";